import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';
import Field from '../common/Field';
import Validator from '../common/Validator';
import User from '../../helpers/user';
import {authApi} from '../../api';
import Alert from "../common/Alert";

class Login extends Reflux.Component {

    constructor(props) {
        super(props);
        this.state = {
            fields: {
                email: {
                    value: '',
                    error: '',
                    role: {
                        required: true,
                    },
                },
                password: {
                    value: '',
                    error: '',
                    role: {
                        required: true,
                    },
                },
            },
            loginFeedback: {
                type: '',
                message: '',
            },
            error: false,
            loading: false,
            success: '',
        };
    }

    setValue = (name, value, error) => {
        this.resetErrorMessage();

        const fields = {
            ...this.state.fields,
            [name]: {
                ...this.state.fields[name],
                value: value,
                error: error,
            },
        };

        this.setState({
            fields: fields,
        });
    };

    loginUser = async () => {
        const validator = Validator.validate(
            this.state.fields,
        );

        this.setState({
            fields: validator.fields,
            error: validator.error,
        });

        if (validator.error) {
            return;
        }

        const data = {
            email: validator.fields.email.value,
            password: validator.fields.password.value,
        };

        this.resetErrorMessage();

        this.setState({
            loading: true,
        });

        try {
            const responseData = await authApi.login(data);

            User.login(responseData);
        } catch (error) {
            if (
                error
                && error.response
                && error.response.status === 422
            ) {
                this.setErrorMessage(
                    error.response.data.message,
                );

                    return;
                }

            this.setErrorMessage(
                'Hiba történt a bejelentkezés során.',
            );
        } finally {
            this.setState({
                loading: false,
            });
    }
    };

    setErrorMessage = (message) => {
        this.setState({
            loginFeedback: {
                type: 'danger',
                message: message,
            },
        });
    };

    resetErrorMessage = () => {
        this.setState({
            loginFeedback: {
                type: '',
                message: '',
            },
        });
    };

    render() {
        return (
            <div className="container">
                <div className="site-login">
                    <h1 className="offset-md-4 col-lg-4 text-center">Bejelentkezés</h1>
                    <p className="offset-md-4 col-lg-4 text-center">
                        Kérjük, adja meg belépési adatait:
                    </p>

                    <div className="row">
                        <div className="col-lg-4 offset-md-4">
                            {this.state.loginFeedback.type.length > 0
                                ? (
                                    <Alert
                                        type={this.state.loginFeedback.type}
                                        message={this.state.loginFeedback.message}
                                    />
                                )
                                : null}
                        </div>
                        <div className="col-lg-4 offset-md-4">
                            <Field
                                type="email"
                                id="login-email"
                                name="email"
                                label="E-mail cím"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue}
                                state={this.state}
                                style={{
                                    width: '100%',
                                }}
                            />
                            <Field
                                type="password"
                                id="login-password"
                                name="password"
                                label="Jelszó"
                                classLabel="control-label"
                                classInput="form-control"
                                setValue={this.setValue}
                                state={this.state}
                                style={{
                                    width: '100%',
                                }}
                            />
                            <div>
                                Ha elfelejtette a jelszavát,{' '}
                                <Link to="/request-password-reset">
                                    ide kattintva
                                </Link>{' '}
                                kérhet újat.
                            </div>
                            <div className="form-group  text-center">
                                <br/>

                                <button
                                    type="button"
                                    onClick={this.loginUser}
                                    className="btn green-btn"
                                    name="login-button"
                                    disabled={this.state.loading}
                                >
                                    {this.state.loading
                                        ? 'Bejelentkezés...'
                                        : 'Bejelentkezés'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/login/Login.js